import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai/react';

import { reactQueryKeys } from '@/config/react-query';
import { useProvider } from '@/hooks/use-provider';
import { authenticatedAtom } from '@/lib/store';
import { PROVIDERS } from '@/providers';

export const useUserInfo = () => {
  const [provider] = useProvider();
  const isAuthenticated = useAtomValue(authenticatedAtom);

  return useQuery({
    queryKey: [reactQueryKeys.userInfo],
    queryFn: provider.getUserInfo,
    enabled:
      isAuthenticated &&
      (provider.id === PROVIDERS.SALESFORCE ||
        provider.id === PROVIDERS.OMNIHIT),
    retry: true,
    staleTime: Infinity,
  });
};
